import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Information18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_599)'>
      <path
        d='M9 7C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5C8.44771 5 8 5.44772 8 6C8 6.55228 8.44771 7 9 7Z'
        fill='currentColor'
      />
      <path d='M8.25 13V8H9.75V13H8.25Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25ZM1.75 9C1.75 4.99594 4.99594 1.75 9 1.75C13.0041 1.75 16.25 4.99594 16.25 9C16.25 13.0041 13.0041 16.25 9 16.25C4.99594 16.25 1.75 13.0041 1.75 9Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_599'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Information18.displayName = 'Information18';
export default Information18;
